//import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
//import { ConditionIndicesApi } from 'api';

export const getAssetKPITrendChartListAction = getApiActionCreator(actionTypes.GET_ASSET_KPI_TREND_LIST);
export const getRetrainingProgressAction = getApiActionCreator(actionTypes.GET_RETRAINING_PROGRESS);

// eslint-disable-next-line import/no-unused-modules
export const getAssetConditionIndicesRequest = (assetID, startDate, endDate) => ({
    type: actionTypes.LOAD_ASSET_KPI_TREND_LIST,
    assetID,
    startDate,
    endDate
});

export const zoomInToSelectedTrendKpiData = (assetID, startDate, endDate) => ({
    type: actionTypes.ZOOM_IN_TO_SELECTED_TREND_KPI_DATA,
    assetID,
    startDate,
    endDate,
});

export const getRetrainingProgress = (assetID, retrainingStartDate) => ({
    type: actionTypes.TRIGGER_RETRAINING,
    assetID,
    retrainingStartDate
});
export const reloadConditionInsights = (assetID) => ({
    type: actionTypes.RELOAD_CONDITION_INSIGHTS,
    assetID
});

export const setIsZoomed = (isZoomed) => ({
    type: actionTypes.SET_CONDITION_INSIGHTS_ZOOM,
    isZoomed
});

export const clearStore = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.CLEAR_STORE,
        });
    };
};

export const setActiveTab = (activeTab) => ({
    type: actionTypes.SET_ACTIVE_CONDITION_INSIGHTS_TAB,
    activeTab
});

export const setDriveAnomalyActiveTab = (driveAnomalyActiveTab) => ({
    type: actionTypes.SET_DRIVE_ANOMALY_ACTIVE_TAB,
    driveAnomalyActiveTab
});

export const setClickedConditionIndex = (index) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_KPI_FROM_SUMMARY_TAB,
            payload: index
        });
    };
};

// eslint-disable-next-line import/no-unused-modules
export const toggleConditionForecast = (enabled) => ({
    type: actionTypes.TOGGLE_CONDITION_FORECAST,
    enabled
});

// eslint-disable-next-line import/no-unused-modules
/*export const getAssetKPITrendChartList = (assetID, startDate, endDate) => {
    return (dispatch) => {
        dispatch(getAssetKPITrendChartListAction(apiCallStatus.LOADING));
        ConditionIndicesApi?.getAssetCondtionInsights(assetID, startDate, endDate)
            .then(details => {
                dispatch(getAssetKPITrendChartListAction(apiCallStatus.SUCCESS, { ...details }));
            }, (err) => {
                dispatch(getAssetKPITrendChartListAction(apiCallStatus.ERROR, null, err));
            });

    };
};*/
